import { render, staticRenderFns } from "./AnalitycsInfoBlock.vue?vue&type=template&id=5db880fc&scoped=true&"
import script from "./AnalitycsInfoBlock.vue?vue&type=script&lang=js&"
export * from "./AnalitycsInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./AnalitycsInfoBlock.vue?vue&type=style&index=0&id=5db880fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db880fc",
  null
  
)

export default component.exports